export const announceNoteAllEn = [
  [
    {
      releaseDate: "2026-09-07T10:00",
      updatedDate: "2026-09-07T10:00",
      announceTitle: "Planning to change your mobile\ndevice?",
      introduction: "infoceanus connect access requires two-factor authentication to keep your private information secure. Occasionally, you will be prompted to use two-factor authentication when logging into connect.\nWe use Microsoft authentication, which requires a registered mobile device with the Microsoft Authenticator application installed.",
      conclusion: "If you are experiencing any other problems or concerns with your infoceanus connect account, please feel free to contact one of our representative at any time.\nHappy sailing!",
    },
    {
      importance: [
        "Please contact a JRCS representative if you are planning to change your phone model.",
      ],
      descriptions: [
        "We will support you in setting up a new, secure access to connect.",
      ],
      images: [],
    },
  ],
];